import { render, staticRenderFns } from "./DarkToggler.vue?vue&type=template&id=07fa538e&"
import script from "./DarkToggler.vue?vue&type=script&lang=js&"
export * from "./DarkToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07fa538e')) {
      api.createRecord('07fa538e', component.options)
    } else {
      api.reload('07fa538e', component.options)
    }
    module.hot.accept("./DarkToggler.vue?vue&type=template&id=07fa538e&", function () {
      api.rerender('07fa538e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/components/DarkToggler.vue"
export default component.exports